import EntityStatus from '@/components/EntityStatus/EntityStatus';
export default EntityStatus;
